import { HTMLAttributes } from "react"
import { cn } from "@/lib/utils"

interface PageHeaderProps extends HTMLAttributes<HTMLDivElement> {
  heading: string
  subheading?: string
  className?: string
}

export function PageHeader({
  heading,
  subheading,
  className,
  ...props
}: PageHeaderProps) {
  return (
    <div className={cn("grid gap-1", className)} {...props}>
      <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-slate-50">
        {heading}
      </h1>
      {subheading && (
        <p className="text-sm text-slate-600 dark:text-slate-400">
          {subheading}
        </p>
      )}
    </div>
  )
}
